import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../services/authentication.service";
import * as $ from 'jquery';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  constructor(private authenticationService:AuthenticationService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/sidebar/sidebar.component.ts